import { render } from "./LiveSiteAlerts.vue?vue&type=template&id=73818e64&scoped=true&ts=true"
import script from "./LiveSiteAlerts.vue?vue&type=script&lang=ts"
export * from "./LiveSiteAlerts.vue?vue&type=script&lang=ts"

import "./LiveSiteAlerts.vue?vue&type=style&index=0&id=73818e64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73818e64"]])

export default __exports__